module.exports = __webpack_public_path__ + "static/img/taxGrigio.6bf8a3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/taxGrigio.png
// module id = csm7
// module chunks = 1